<!-- Content -->
<div class="content container-fluid">
  <!-- Page Header -->
  <header class="page-header">
    <nav attr.aria-label="{{ 'wcag.breadcrumb' | translate }}">
      <ol class="breadcrumb">
        <breadcrumb></breadcrumb>
        &nbsp; / &nbsp;
        <li class="breadcrumb-item active">
          {{ (sale$ | async)?.id }}
        </li>
      </ol>
    </nav>
    <div class="page-header-grid grid-sm">
      <h1 class="page-header-title">
        {{ (sale$ | async)?.id }}
      </h1>

      <!-- Cancel button, multi flow DISABLED  -->

      <div
        class="spinner-border"
        role="status"
        attr.aria-label="{{ 'general.loading' | translate }}"
        *ngIf="isLoading$ | async"
      >
      </div>
      <div class="d-flex align-items-center">
        <div dropdown [canSee]="[accessRights.Sales_write]" class="btn-group">
          <div class="d-flex align-items-center">
            <button
              class="btn btn-sm btn-white dropdown-toggle"
              dropdownToggle
              type="button"
            >
              {{ 'general.actions' | translate }}
            </button>
            <ul
              *dropdownMenu
              class="dropdown-menu dropdown-menu-right"
              role="menu"
            >
              <li>
                <a
                  href="javascript:;"
                  [hidden]="isLoading$ | async"
                  *ngIf="sale$ | async"
                  class="dropdown-item dropdown-toggle"
                  (click)="onClickCancel()"
                  [canSee]="[
                    accessRights.Sales_write,
                    accessRights.Sales_delete
                  ]"
                >
                  {{ 'saleModule.fullSaleCancel' | translate }}
                  <span class="caret"></span
                ></a>
              </li>
              <li
                *ngIf="
                  (sale$ | async) &&
                  saleModuleConfig.cancelationPolicy
                "
              >
                <a
                  href="javascript:;"
                  [canSee]="[accessRights.Sales_write]"
                  *ngIf="
                    (sale$ | async)?.statusCode == saleStatusCode.CANCELLED ||
                    saleContainsSubscription ||
                    (sale$ | async)?.total < 0
                  "
                  [ngClass]="{
                    'opacity-50':
                      (sale$ | async)?.statusCode == saleStatusCode.CANCELLED ||
                      saleContainsSubscription ||
                      (sale$ | async)?.total < 0
                  }"
                  [hidden]="isLoading$ | async"
                  class="dropdown-item dropdown-toggle"
                >
                  {{ 'saleModule.cancelSaleByPolicy' | translate }}
                </a>
                <a
                  href="javascript:;"
                  [canSee]="[accessRights.Sales_write]"
                  *ngIf="
                    !(
                      (sale$ | async)?.statusCode == saleStatusCode.CANCELLED ||
                      saleContainsSubscription ||
                      (sale$ | async)?.total < 0
                    )
                  "
                  [hidden]="isLoading$ | async"
                  (click)="openCancelPolicyModal()"
                  class="dropdown-item dropdown-toggle"
                >
                  {{ 'saleModule.cancelSaleByPolicy' | translate }}
                </a>
              </li>
              <li>
                <a
                  href="javascript:;"
                  [hidden]="isLoading$ | async"
                  *ngIf="(sale$ | async) && (operationsPending$ | async)"
                  (click)="approveOperationSale()"
                  class="dropdown-item dropdown-toggle"
                  [canSee]="[
                    accessRights.Sales_write,
                    accessRights.Sales_delete
                  ]"
                >
                  {{ 'general.approveOperation' | translate }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </header>

  <!-- Nav -->
  <nav attr.aria-label="{{ 'wcag.saleMenu' | translate }}">
    <ul
      class="nav nav-tabs align-items-center mb-3"
      *ngIf="sale$ | async as sale"
      role="tablist"
    >
      <!-- WCAG SKIP link -->
      <!-- <li class="nav-item">
        <a class="nav-link visually-hidden-focusable" href="#saleConent">{{
          'wcag.skipNavigation' | translate
        }}</a> </li
      > -->
      <!-- END WCAG skip link -->
      <li class="nav-item">
        <a
          [routerLink]="['/sales/', sale.id]"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          class="nav-link"
          role="tab"
          #rla="routerLinkActive"
          data-test-id="sale-general-tab"
          [attr.aria-selected]="rla.isActive ? 'true' : 'false'"
        >
          <i role="img" class="fa fa-cube me-1" aria-hidden="true"></i>
          {{ 'general.general' | translate }}
        </a>
      </li>
      <li
        class="nav-item"
        *ngIf="
          hasRequiredRole$(moduleConfigs.saleModule.rolesWithWritePermission)
            | async
        "
      >
        <a
          [routerLink]="['/sales', sale.id, 'activities']"
          routerLinkActive="active"
          class="nav-link"
          role="tab"
          #rla1="routerLinkActive"
          data-test-id="sale-logs-tab"
          [attr.aria-selected]="rla1.isActive ? 'true' : 'false'"
        >
          <i role="img" class="fa fa-file me-1" aria-hidden="true"></i>
          {{ 'activityModule.logs' | translate }}
        </a>
      </li>
      <li
        class="nav-item"
        *ngIf="
          hasRequiredRole$(moduleConfigs.saleModule.rolesWithWritePermission)
            | async
        "
      >
        <a
          [routerLink]="['/sales', sale.id, 'actions']"
          routerLinkActive="active"
          class="nav-link"
          role="tab"
          #rla2="routerLinkActive"
          data-test-id="sale-actions-tab"
          [attr.aria-selected]="rla2.isActive ? 'true' : 'false'"
        >
          <i
            role="img"
            class="fa fa-arrow-circle-up me-1"
            aria-hidden="true"
          ></i>
          {{ 'general.actions' | translate }}
        </a>
      </li>
      <li
        class="nav-item"
        *ngIf="
          hasRequiredRole$(moduleConfigs.saleModule.rolesWithWritePermission)
            | async
        "
      >
        <a
          class="nav-link"
          [routerLink]="['/sales/', sale.id, 'documents']"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          role="tab"
          #rla3="routerLinkActive"
          data-test-id="sale-documents-tab"
          [attr.aria-selected]="rla3.isActive ? 'true' : 'false'"
        >
          <i role="img" class="fa fa-image me-1" aria-hidden="true"></i>
          {{ 'general.documents' | translate }}
        </a>
      </li>
      <li
        class="nav-item"
        *ngIf="
          hasRequiredRole$(moduleConfigs.saleModule.rolesWithWritePermission)
            | async
        "
      >
        <a
          class="nav-link"
          [routerLink]="['/sales/', sale.id, 'bookings']"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          role="tab"
          #rla4="routerLinkActive"
          data-test-id="sale-bookings-tab"
          [attr.aria-selected]="rla4.isActive ? 'true' : 'false'"
        >
          <i role="img" class="fa fa-calendar-alt me-1" aria-hidden="true"></i>
          {{ 'bookingModule.bookings' | translate }}
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          [routerLink]="['/sales/', sale.id, 'communication']"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          role="tab"
          #rla5="routerLinkActive"
          data-test-id="sale-communication-tab"
          [attr.aria-selected]="rla5.isActive ? 'true' : 'false'"
        >
          <i role="img" class="fa fa-comment me-1" aria-hidden="true"></i>
          {{ 'communicationModule.communication' | translate }}
        </a>
      </li>
      <li
        class="nav-item"
        *ngIf="
          saleModuleConfig.multiDayFlow &&
          (multidayEnabled$ | async) &&
          (hasRequiredRole$(moduleConfigs.saleModule.rolesWithWritePermission)
            | async)
        "
      >
        <a
          class="nav-link"
          [routerLink]="['/sales/', sale.id, 'organize']"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          role="tab"
          #rla6="routerLinkActive"
          data-test-id="sale-organize-bookings-tab"
          [attr.aria-selected]="rla6.isActive ? 'true' : 'false'"
        >
          <i role="img" class="fa fa-book-open me-1" aria-hidden="true"></i>
          {{ 'general.organizeBookings' | translate }}
        </a>
      </li>
      <li class="nav-item" [canSee]="[accessRights.Sales_write]">
        <a
          class="nav-link"
          [routerLink]="['/sales/', sale.id, 'operations']"
          (click)="fetchDocuments()"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          role="tab"
          #rla7="routerLinkActive"
          data-test-id="sale-operations-tab"
          [attr.aria-selected]="rla7.isActive ? 'true' : 'false'"
        >
          <i role="img" class="fa fa-cube" aria-hidden="true"></i>
          {{ 'operationModule.operations' | translate }}
        </a>
      </li>
      <li
        class="nav-item"
        [canSee]="[accessRights.Sales_write]"
        *ngIf="(answers$ | async)?.length > 0"
      >
        <a
          class="nav-link"
          [routerLink]="['/sales/', sale.id, 'surveys']"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          role="tab"
          #rla8="routerLinkActive"
          data-test-id="sale-surveys-tab"
          [attr.aria-selected]="rla8.isActive ? 'true' : 'false'"
        >
          <i role="img" class="fa fa-chart-bar" aria-hidden="true"></i>
          {{ 'productModule.surveys' | translate }}
        </a>
      </li>
    </ul>
  </nav>
  <!-- End Nav -->

  <div id="saleConent">
    <router-outlet (activate)="subscribeToEmitter($event)"></router-outlet>
  </div>
</div>
